import styled from 'styled-components';
import { colors } from 'globalStyles';

export const Label = styled.label``;

export const Input = styled.input`
  /* Visually hidden but FOCUSABLE (display:none removed a keyboard user's
     only way to toggle the field) — sized over the Indicator so pointer hits
     land on the real control, with a visible focus ring on the Indicator. */
  position: absolute;
  opacity: 0;
  width: 20px;
  height: 20px;
  margin: 0;
  cursor: pointer;

  &:focus-visible + div {
    outline: 2px solid ${colors.MAIN_COLOR};
    outline-offset: 2px;
  }

  &:checked + div {
    background-color: ${colors.LIGHT_GREEN};
    border: solid 2px ${colors.LIGHT_GREEN};
  }

  &:checked + div:after {
    content: '';
    display: block;
    position: relative;
    left: 5px;
    width: 4px;
    height: 9px;
    border: solid ${colors.WHITE};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
`;

export const Indicator = styled.div`
  width: 20px;
  height: 20px;
  border: solid 2px ${colors.LIGHTER_GRAY};
  border-radius: 2px;
  margin-right: 12px;

  &:hover {
    cursor: pointer;
  }
`;
